import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

// Icon per entity kind; anything unmapped gets a neutral one, so new kinds
// added on the agent side render without an FE change.
const KIND_ICONS = {
  seller_profile: "badge",
  inbox: "mail",
  account_list: "domain",
  contact_list: "group"
};

/**
 * List-shaped tool results (seller profiles, inboxes, account lists…) as a
 * card grid. Clicking a card opens the FULL record in the canvas detail
 * panel — the card only carries the scannable summary.
 */
const EntityCardsBlock = observer(({ block }) => {
  const items = block.items || [];
  if (!items.length) return null;
  const icon = KIND_ICONS[block.kind] || "web_stories";
  const activeId =
    copilotStore.entityPanel.open &&
    copilotStore.entityPanel.blockId === block.id
      ? copilotStore.entityPanel.itemId
      : null;

  return (
    <div className="copilotEntityCards">
      <div className="copilotEntityCards__title">
        <i className="material-icons-outlined">{icon}</i>
        <span>{block.title}</span>
        <span className="copilotEntityCards__count">{items.length}</span>
      </div>
      <div className="copilotEntityCards__grid">
        {items.map(item => (
          <button
            type="button"
            key={item.id}
            className={`copilotEntityCard ${
              activeId === item.id ? "active" : ""
            }`}
            onClick={() => copilotStore.openEntityPanel(block.id, item.id)}
          >
            <div className="copilotEntityCard__top">
              <span className="copilotEntityCard__title">{item.title}</span>
              <i className="material-icons-outlined copilotEntityCard__open">
                chevron_right
              </i>
            </div>
            {item.subtitle && (
              <div className="copilotEntityCard__subtitle">{item.subtitle}</div>
            )}
            {(item.badges || []).length > 0 && (
              <div className="copilotEntityCard__badges">
                {item.badges.map(badge => (
                  <span key={badge} className="copilotEntityCard__badge">
                    {badge}
                  </span>
                ))}
              </div>
            )}
            {(item.fields || []).length > 0 && (
              <div className="copilotEntityCard__fields">
                {item.fields.slice(0, 2).map(field => (
                  <div key={field.label} className="copilotEntityCard__field">
                    <span className="copilotEntityCard__fieldLabel">
                      {field.label}
                    </span>
                    <span className="copilotEntityCard__fieldValue">
                      {field.value}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
});

export default EntityCardsBlock;
